import { SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Layout, Modal } from 'antd';
import React from 'react';
import Timer from 'react-compound-timer';
import { isChrome, isFirefox } from 'react-device-detect';
import { showModal } from '../../store/actions/AssessmentActions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { interviewRoleMap, isCookieExpired } from '../../helperFunctions';
import { get_image_endpoint } from '../../ImageEndpoint';
import { history } from '../../index';
import {
  loginForInterviewCA,
  loginUsingGoogleForInterview,
  requestOTP,
} from '../../store/actions/AuthActions';
import * as interviewActions from '../../store/actions/InterviewActions';
import * as actions from '../../store/actions/InterviewInviteActions';
import EmailForm from '../InviteUI/EmailForm';
import OTPForm from '../InviteUI/OTPForm';
import WrappedInterviewerLoginForm from './InterviewerLoginForm';
import styles from './InterviewInviteUIContainer.scss';
import Lock from '../../assets/images/Lock.png';

const { Content } = Layout;

class InterviewInviteUIContainer extends React.Component {
  constructor(props) {
    super(props);
    let urlparams = new URLSearchParams(this.props.location.search);
    this.state = {
      interview_id: urlparams.get('interview_id'),
      hash_value: urlparams.get('hash_value'),
      user_role: urlparams.get('role'),
      company_id: urlparams.get('company_id'),
      showLogin: false,
      otp: '',
      error: false,
    };
  }

  componentDidMount() {
    if (!localStorage.getItem('interview_id'))
      localStorage.setItem('interview_id', this.state.interview_id);
    this.props.fetchInterviewInvite(
      this.state.interview_id,
      this.state.hash_value,
      this.state.user_role,
      this.state.company_id,
      false,
      () => this.callback(),
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOtp.status !== this.props.isOtp.status) {
      if (this.props.isOtp.status) {
        this.setState({
          error: this.props.isOtp.status === 'invalid' || this.props.isOtp.status === 'expired',
        });
      }
    }
  }

  callback = () => {
    let urlparams = new URLSearchParams(this.props.location.search);
    if (localStorage.getItem('access-token') && !isCookieExpired()) {
      history.push('/interview?interview_id=' + urlparams.get('interview_id'));
    }
  };

  handleGoogleResponse = response => {
    const { t } = this.props;

    if (response.error === 'idpiframe_initialization_failed') {
      let url, option;
      if (isChrome) {
        url = 'chrome://settings/cookies';
        option = t('interview_invite.cookies.chrome_option');
      } else if (isFirefox) {
        url = 'about:preferences#privacy';
        option = t('interview_invite.cookies.firefox_option');
      }
      this.props.dispatch(
        showModal({
          type: 'error',
          title: t('interview_invite.cookies.title'),
          content: (
            <div>
              <p>{t('interview_invite.cookies.description')}</p>
              {url ? (
                <div>
                  <br />
                  <p>{t('interview_invite.cookies.paste_url')}</p>
                  <p>
                    <strong>{url}</strong>
                  </p>
                  {option}
                  <br />
                </div>
              ) : (
                <div>
                  <br />
                </div>
              )}
              <p>{t('interview_invite.cookies.footer')}</p>
            </div>
          ),
          okText: t('interview_invite.cookies.refresh'),
          onOk: () => {
            window.location.reload(false);
          },
        }),
      );
    }

    const payload = {
      provider: 'google',
      company_id: this.state.company_id,
      code: response.code,
      callback: () => this.props.startInterview(this.state.interview_id),
    };
    this.props.loginUsingGoogleForInterview(payload);
  };

  handleRequestOTP = values => {
    const { t } = this.props;
    const enteredEmail = values.email;
    if (enteredEmail === this.props.email_id) {
      this.props.requestOTP(this.props.email_id, this.props.login_token);
    } else {
      Modal.error({
        title: t('interview_invite.email_mismatch.title'),
        content: t('interview_invite.email_mismatch.message'),
        okText: t('interview_invite.email_mismatch.ok'),
      });
    }
  };

  handleOtpChange = value => {
    this.setState({ otp: value });
  };

  handleOTPSubmit = () => {
    const payload = {
      email: this.props.email_id,
      company_id: this.state.company_id,
      otp: this.state.otp,
      callback: () => this.props.startInterview(this.state.interview_id),
    };
    this.props.loginOTP(payload);
  };

  showLoginButton = () => {
    this.setState({
      showLogin: true,
    });
  };

  render() {
    const { t } = this.props;

    let remainingTime;
    if (this.props.start_time !== undefined) {
      var curr_date = new Date().getTime() / 1000;
      var interview_date = new Date(this.props.start_time);
      interview_date = interview_date.getTime() / 1000;
      remainingTime = interview_date - curr_date;
    }

    let developer, candidate;
    if (this.props.participants) {
      developer = this.props.participants.filter(e => e.role === 'IN');
      candidate = this.props.participants.filter(e => e.role === 'CA');
    }

    if (remainingTime && remainingTime <= 0 && !this.state.showLogin) this.showLoginButton();
    if (remainingTime && remainingTime < 0) remainingTime = 0;

    const renderContent = () => {
      switch (this.props.isOtp.status) {
        case 'send':
        case 'invalid':
        case 'expired':
          return (
            <div>
              <OTPForm
                otp={this.state.otp}
                onChange={this.handleOtpChange}
                onSubmit={() => {
                  this.handleOTPSubmit();
                }}
                error={this.state.error}
                disabled={this.state.otp.length !== 6}
                email_id={this.props.email_id}
                message={this.props.isOtp.message}
              />
            </div>
          );

        case 'idle':
          return (
            <>
              <EmailForm
                email_id={this.props.email_id}
                onRequestOTP={this.handleRequestOTP}
                onGoogleResponse={this.handleGoogleResponse}
              />
            </>
          );

        case 'Account Locked':
          return (
            <div>
              <img
                src={Lock}
                alt={t('interview_invite.account_locked.alt')}
                style={{ width: 50, height: 50, marginBottom: 20 }}
              />
              <p style={{ fontWeight: 700, fontSize: 24 }}>
                {t('interview_invite.account_locked.title')}
              </p>
              <p style={{ fontSize: 14, color: 'red', padding: 0 }}>
                {t('interview_invite.account_locked.message')}
              </p>
              <span style={{ fontSize: 14, color: 'red' }}>
                {t('interview_invite.account_locked.retry', { duration: '60 mins' })}
              </span>
            </div>
          );

        default:
          return null;
      }
    };

    return (
      <div className={styles['c-interview-invite']}>
        {this.state.user_role === 'CA' ? (
          <React.Fragment>
            <div className={styles['c-interview-invite__heading']}>
              {this.props.company_details.alias && (
                <div className={styles['c-invite__logo']}>
                  <img
                    src={get_image_endpoint(this.props.company_details.alias, 'light')}
                    alt={this.props.company_details.name + ' logo'}
                  />
                </div>
              )}
              <div className={styles['c-interview-invite__title']}>
                <h5>{t('interview_invite.coding_interview')}</h5>
              </div>
            </div>

            <div className={styles['c-interview-invite__name']}>
              <p>
                {t('interview_invite.interview_with')} {developer ? developer[0].name : ''}
              </p>
            </div>

            <div className={styles['c-interview-invite__timer']}>
              {remainingTime !== undefined ? (
                <Timer
                  initialTime={remainingTime * 1000}
                  direction="backward"
                  formatValue={value => {
                    return `${value < 10 ? `0${value}` : value}`;
                  }}
                  checkpoints={[
                    {
                      time: 0,
                      callback: () => this.showLoginButton(),
                    },
                  ]}
                >
                  {() => (
                    <React.Fragment>
                      <div className={styles['c-interview-invite__details__days']}>
                        <p>
                          <Timer.Days />
                        </p>
                        <p className={styles['c-interview-invite__details-tag']}>
                          {t('interview_invite.timer.days')}
                        </p>
                      </div>
                      <div className={styles['c-interview-invite__details__hours']}>
                        <p>
                          <Timer.Hours />
                        </p>
                        <p className={styles['c-interview-invite__details-tag']}>
                          {t('interview_invite.timer.hours')}
                        </p>
                      </div>
                      <div className={styles['c-interview-invite__details__minutes']}>
                        <p>
                          <Timer.Minutes />
                        </p>
                        <p className={styles['c-interview-invite__details-tag']}>
                          {t('interview_invite.timer.minutes')}
                        </p>
                      </div>
                      <div className={styles['c-interview-invite__details__seconds']}>
                        <p>
                          <Timer.Seconds />
                        </p>
                        <p className={styles['c-interview-invite__details-tag']}>
                          {t('interview_invite.timer.seconds')}
                        </p>
                      </div>
                    </React.Fragment>
                  )}
                </Timer>
              ) : null}
            </div>

            <div className={styles['c-interview-invite__login']}>
              {this.state.showLogin ? renderContent() : null}
            </div>
          </React.Fragment>
        ) : (
          <div className={styles['login__form']}>
            <Layout className={styles.login}>
              <Content className={styles['login__content']}>
                <div className={styles['login__form__content']}>
                  {this.props.company_details.alias && (
                    <div className={styles['login__logo']}>
                      <img
                        src={get_image_endpoint(this.props.company_details.alias, 'light')}
                        alt={this.props.company_details.name + ' logo'}
                        style={{ width: '100%' }}
                      />
                      <h5 style={{ paddingLeft: '0px', fontSize: '1.45rem' }}>
                        {t('interview_invite.coding_interview')}
                      </h5>
                    </div>
                  )}
                  <hr style={{ width: '75%', borderTop: '0.0613vw solid #1890FF' }} />
                  <div className={styles['login__candidateinfo']}>
                    <div className={styles['candidateinfo__user']}>
                      <UserOutlined style={{ fontSize: '1.2vw', marginRight: '0.6vw' }} />
                      <p>
                        <span style={{ fontWeight: 'bold' }}>
                          {t('interview_invite.candidate_label')}
                        </span>{' '}
                        {candidate ? candidate[0].name : ''}
                      </p>
                    </div>
                    <div className={styles['candidateinfo__role']}>
                      <SettingOutlined style={{ fontSize: '1.2vw', marginRight: '0.6vw' }} />
                      <p>
                        <span style={{ fontWeight: 'bold' }}>
                          {t('interview_invite.role_label')}
                        </span>{' '}
                        {this.props.interview_role
                          ? interviewRoleMap[this.props.interview_role]
                          : ''}
                      </p>
                    </div>
                  </div>
                  <hr style={{ width: '75%', borderTop: '0.0613vw solid #1890FF' }} />
                  <h5 className={styles['candidate__sign-in']}>{t('interview_invite.sign_in')}</h5>
                  <div>
                    <WrappedInterviewerLoginForm />
                  </div>
                </div>
              </Content>
            </Layout>
          </div>
        )}

        <div className={styles['c-interview-invite__footer']}>
          <p>
            {t('interview_invite.footer', {
              year: new Date().getFullYear(),
            })}
          </p>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch,
  loginUsingGoogleForInterview: payload => dispatch(loginUsingGoogleForInterview(payload)),
  fetchInterviewInvite: (
    interview_id,
    hash_value,
    role,
    company_id,
    fetch_interview_data,
    callback,
  ) =>
    dispatch(
      actions.fetchInterviewInvite(
        interview_id,
        hash_value,
        role,
        company_id,
        fetch_interview_data,
        callback,
      ),
    ),
  startInterview: interview_id => dispatch(actions.startInterview(interview_id)),
  requestOTP: (email, token) => dispatch(requestOTP(email, token)),
  loginOTP: payload => dispatch(loginForInterviewCA(payload)),
});

const mapStateToProps = state => ({
  interview_id: state.interview.interview_id,
  interview_status: state.interview.status,
  interview_title: state.interview.title,
  interview_role: state.interview.role,
  participants: state.interview.participants,
  start_time: state.interview.start_time,
  role: state.interview.role,
  user_id: state.auth.user_id,
  company_details: state.auth.company_details,
  login_token: state.interview.login_token,
  isOtp: state.auth.otp,
  email_id: state.interview.email_id,
  username: state.auth.username,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation('auth')(InterviewInviteUIContainer)),
);
